/* Package JSON Import will be here */
import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { ConnectedRouter } from "connected-react-router";
import { ErrorBoundary } from "react-error-boundary";
/* Package JSON Import will be here */

/* Project Import will be here */
import App from "./app/App";
import registerServiceWorker from "./registerServiceWorker";
import store from "./app/store";
import { history } from "./app/rootReducer";
import { onErrorTrack } from "../src/hooks/exceptionHandling";
/* Project Import will be here */

ReactDOM.render(
  <Provider store={store}>
    <ErrorBoundary FallbackComponent={() => null} onError={onErrorTrack}>
      <ConnectedRouter history={history}>
        <App />
      </ConnectedRouter>
    </ErrorBoundary>
  </Provider>,
  document.getElementById("root")
);

registerServiceWorker();